<div class="bundle-info flex flex--nowrap">
  <!-- Placeholder art until per-bundle media is sourced from the catalog (later step). -->
  <div class="bundle-info__image flex flex--center flex--middle">
    <fcom-icon class="icon-large white-text" [name]="SvgLibraryIcon.PLUS" />
  </div>

  <div class="bundle-info__content flex flex--column">
    @if (bundleName) {
      <h3 class="font-heading-5 font-title-medium nordic-blue-900-text" data-testid="ancillary-bundle-title">
        {{ bundleName }}
      </h3>
    }

    @if (bundleDescription) {
      <p
        class="font-body-1 ms-xxsmall-t"
        data-testid="ancillary-bundle-description"
        [innerHTML]="bundleDescription"
      ></p>
    }

    <span class="bundle-info__discount font-body-2 bold-type ms-xsmall-t" data-testid="ancillary-bundle-discount">{{
      'ancillaries.bundle.toggle.comboOfferText' | finLocalization
    }}</span>
  </div>
</div>
